
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-slate-900/95 backdrop-blur-sm border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <button 
              onClick={() => navigate('/')}
              className="text-xl font-bold text-white hover:text-teal-400 transition-colors cursor-pointer"
            >
              LoanGuide Pro
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => navigate('/appraisal-guidelines')}
              className="text-slate-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Guidelines
            </button>
            <button 
              onClick={() => navigate('/assessor-directory')}
              className="text-slate-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Assessor Directory
            </button>
            <button 
              onClick={() => navigate('/resources')}
              className="text-slate-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Resources
            </button>
            <button 
              onClick={() => navigate('/pricing')}
              className="text-slate-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Pricing
            </button>
            <button 
              onClick={() => navigate('/support')}
              className="text-slate-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Support
            </button>
          </nav>

          {/* CTA Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            <button 
              onClick={() => navigate('/login')}
              className="text-slate-300 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              Sign In
            </button>
            <button 
              onClick={() => navigate('/register')}
              className="bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              Get Started
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-slate-300 hover:text-white cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-800">
            <nav className="flex flex-col space-y-4">
              <button 
                onClick={() => {
                  navigate('/appraisal-guidelines');
                  setIsMenuOpen(false);
                }}
                className="text-slate-300 hover:text-teal-400 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                Guidelines
              </button>
              <button 
                onClick={() => {
                  navigate('/assessor-directory');
                  setIsMenuOpen(false);
                }}
                className="text-slate-300 hover:text-teal-400 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                Assessor Directory
              </button>
              <button 
                onClick={() => {
                  navigate('/resources');
                  setIsMenuOpen(false);
                }}
                className="text-slate-300 hover:text-teal-400 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                Resources
              </button>
              <button 
                onClick={() => {
                  navigate('/pricing');
                  setIsMenuOpen(false);
                }}
                className="text-slate-300 hover:text-teal-400 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                Pricing
              </button>
              <button 
                onClick={() => {
                  navigate('/support');
                  setIsMenuOpen(false);
                }}
                className="text-slate-300 hover:text-teal-400 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                Support
              </button>
              <button 
                onClick={() => {
                  navigate('/login');
                  setIsMenuOpen(false);
                }}
                className="text-slate-300 hover:text-teal-400 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                Sign In
              </button>
              <button 
                onClick={() => {
                  navigate('/register');
                  setIsMenuOpen(false);
                }}
                className="bg-teal-600 text-white px-4 py-2 rounded-lg hover:bg-teal-500 transition-colors text-left cursor-pointer whitespace-nowrap"
              >
                Get Started
              </button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
